import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DesignSystemModule } from '@peca/design-system';

@Component({
  selector: 'peca-main-navigation',
  templateUrl: './main-navigation.component.html',
  styleUrl: './main-navigation.component.scss',
  imports: [RouterOutlet, DesignSystemModule],
})
export class MainNavigationComponent {}
